<template>
  <div class="col-md-12 mx-auto p-0">
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :title="contact.firstname + ' ' + contact.lastname" routeBack="ContactIndex"/>
        <div>
          <button class="show-action-btn edit mr-1" @click="clickOnEditBtn()">
            <pencil-icon size="18"/>
          </button>
          <button class="show-action-btn delete" @click="clickOnDeleteBtn()">
            <trash-icon size="18"/>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <div class="row">
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('contact.Lastname') }}</div>
                  <div> {{ getValue("lastname") }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('contact.Firstname') }}</div>
                  <div> {{ getValue("firstname") }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('contact.Type') }}</div>
                  <div> {{ getValue("type") }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('contact.Address') }}</div>
                  <div> {{ getValue("address") + ' - ' + getValue("postalCode") + ' - ' + getValue("city") }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('contact.PhoneNumber') }}</div>
                  <div> {{ getValue("phoneNumber") }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('contact.Mail') }}</div>
                  <div> {{ getValue("mail") }}</div>
                </div>
              </div>
            </div>

            <div class="bold-text level-two-title my-2 main-red-color">
              {{ $t('ContactDocuments') }}
            </div>

            <div v-for="document in validDocuments" class="row">
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ document['name'] }}</div>
                  <b-link class="light-blue-color underline-text" v-on:click="getDocument(document['fileUrl'])">
                    {{ document['fileName'] }}
                  </b-link>
                </div>
              </div>

              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('contactDocument.ExpirationDate') + ' ' + document['name'] }}</div>
                  <div> {{ document['date'] }}</div>
                </div>
              </div>
            </div>
          </b-card>

          <b-card class="shadow-sm">
            <div class="row d-flex flex-row justify-content-between align-items-center">
              <div v-b-toggle.history class="col-8 bold-text level-two-title my-2 main-red-color">
                {{ $t('contactDocument.history') }}
              </div>
              <div v-b-toggle.history class="mx-3">
                <caret-down-icon></caret-down-icon>
              </div>
            </div>

            <!-- Collapsible part -->
            <b-collapse id="history" class="row flex-row align-items-end">
              <template v-for="document in historyDocuments">
                <div class="col-md-6">
                  <div class="d-flex flex-column mb-4">
                    <div class="bold-text"> {{ document['name'] }}</div>
                    <b-link v-on:click="getDocument(document['fileUrl'])"> {{ document['fileName'] }}</b-link>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="d-flex flex-column mb-4">
                    <div class="bold-text"> {{ $t('contactDocument.ExpirationDate') + ' ' + document['name'] }}</div>
                    <div> {{ document['date'] }}</div>
                  </div>
                </div>
              </template>
            </b-collapse>
          </b-card>

          <b-card v-if="operationDevis && operationDevis.length > 0" class="shadow-sm mt-4">
            <div class="row d-flex flex-row justify-content-between align-items-center">
              <div v-b-toggle.devis class="col-8 bold-text level-two-title my-2 main-red-color">
                {{ $t('Devis') }}
              </div>
              <div v-b-toggle.devis class="mx-3">
                <caret-down-icon></caret-down-icon>
              </div>
            </div>

            <!-- Collapsible part -->
            <b-collapse id="devis" class="row flex-row align-items-end">
              <div class="col-12">
                <b-table id="table-devis" ref="table"
                         :fields="tableFieldsDevis"
                         :items="operationDevis"
                         :thead-class="'row-header'"
                         borderless
                         show-empty
                         sort-icon-left
                         stacked="lg"
                         striped>

                  <template #cell(operationConstruction)="data">
                    <template v-if="data.value.name!==''">
                      <div class="d-flex">
                        <div>{{ data.value.name }}</div>
                        <div v-if="data.value.name&&data.value.bilanType">
                        <span
                          :class="{'bilan-exe':data.value.bilanType==='EXE','bilan-avp':data.value.bilanType==='AVP'}"
                          class="bilanType-vignette">{{ data.value.bilanType }}</span>
                        </div>
                      </div>
                    </template>
                  </template>

                  <template #cell(prixTTC)="data">
                    <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
                  </template>

                  <template #cell(status)="data">
                    <div :style="{color: data.item.status.mainColor.toString() }">
                      {{ $t(data.item.status.text) }}
                    </div>
                  </template>

                  <template #cell(documents)="data">
                    <div v-for="document in data.item.documents" class="row">
                      <b-link class="light-blue-color underline-text ml-3 mb-1"
                              v-on:click="getDocument(document.fileUrl)">
                        {{ truncateText(document.fileName, 45) }}
                      </b-link>
                    </div>
                  </template>

                  <template #empty="scope">
                    <div class="no-result">
                      <div class="text-center mt-5 mb-4">
                        <img :src="require(`@/assets/images/APRILYOS/empty-table.png`)" alt="no result"
                             class="no-result-img"
                             width="90%">
                      </div>
                      <div class="no-result-text">
                        <div class="no-result-title mb-2">{{ $t("devis.emptyTitle") }}</div>
                      </div>
                    </div>
                  </template>

                </b-table>
              </div>
            </b-collapse>
          </b-card>

        </div>
      </div>
    </b-container>

    <Item-delete-modal
      :beginsWithVoyel="false"
      :isFeminine="false"
      :selectedItem="selectedContact"
      controllerName="contact"
      itemSingularName="contact"
      itemSingularNameUpp="Contact"
      @didDeleteItem="didDeleteContact()">
    </Item-delete-modal>

  </div>
</template>

<script>

import BackArrow from "../../components/b122/BackArrow";
import ItemDeleteModal from "../../components/b122/ItemDeleteModal";
import api from "../../services/api";

export default {
  name: "ContactShow",

  components: {
    BackArrow,
    ItemDeleteModal
  },

  data() {
    return {
      contactId: this.$route.params.contactId,
      contact: {
        lastname: null,
        firstname: null,
        type: null,
        address: null,
        postalCode: null,
        city: null,
        phoneNumber: null,
        mail: null
      },
      selectedContact: null,
      validDocuments: [],
      historyDocuments: [],
      operationDevis: [],
      allowDelete: null,
      tableFieldsDevis: [
        {
          label: this.$t('operationConstruction.Name'),
          key: 'operationConstruction',
          sortable: false,
          thStyle: {width: "20%"}
        },
        {
          label: this.$t("devis.PrixTTC"),
          key: 'prixTTC',
          sortable: false,
          thStyle: {width: "15%"}
        },
        {
          label: this.$t('OperationTask.status'),
          key: 'status',
          sortable: false,
          thStyle: {width: "15%"}
        },
        {
          label: this.$t('ContactDocuments'),
          key: 'documents',
          sortable: false,
          thStyle: {width: "25%"}
        },
      ],
    }
  },

  mounted() {
    this.fetchData()
  },

  computed: {
    getValue() {
      return property => (this.contact[property] || this.contact[property] === false) ? this.contact[property] : 'N/A'
    },
  },


  methods: {

    async fetchData() {
      await this.fetchContactInfos()
      await this.fetchAuthorization()
    },

    async fetchContactInfos() {
      await api
        .get(`/contact/${this.contactId}`)
        .then(response => {
          this.contact.lastname = response.data.lastname
          this.contact.firstname = response.data.firstname
          this.contact.type = response.data.type
          this.contact.address = response.data.address
          this.contact.postalCode = response.data.postalCode
          this.contact.city = response.data.city
          this.contact.phoneNumber = response.data.phoneNumber
          this.contact.mail = response.data.mail
          this.contact.tostring = response.data.tostring
          this.validDocuments = response.data.validDocuments
          this.historyDocuments = response.data.historyDocuments
          this.selectedContact = response.data
          this.operationDevis = response.data.operationDevis
        })
    },

    async fetchAuthorization() {
      await api
        .get(`/contact/getAuthorization/${this.contactId}`)
        .then(response => {
          this.allowDelete = response.data.allowDelete
        })
    },

    getDocument(fileUrl) {
      let url = process.env.SERVER_URL + fileUrl
      window.open(url, '_blank').focus();
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'ContactEdit',
        params: {
          contactId: this.contactId
        }
      })
    },

    clickOnDeleteBtn() {
      if (this.operationDevis && this.operationDevis.length > 0) {
        this.$alert(this.$i18n.t('contact.cant.delete.devis.linked', {contactName: this.contact.tostring}).toString()).then(() => {
        });
      } else {
        this.$bvModal.show('item-delete-modal')
      }
    },

    didDeleteContact() {
      this.$router.push({
        name: 'ContactIndex'
      })
      this.$nextTick(() => {
        this.successToast(this.contact.firstname + ' ' + this.contact.lastname)
      })
    },

    successToast(contactName) {
      this.$bvToast.toast(this.$i18n.t('Contact') + ' "' + contactName + '" ' + this.$i18n.t('deleted'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    },

    convertDateToStr(dateMillis) {
      return new Date(dateMillis).toLocaleDateString('fr-fr', {
        weekday: "long",
        year: "numeric",
        month: "short",
        day: "numeric"
      })
    },

    convertToEuros(value) {
      let euros = (value / 100).toFixed(2);
      return Intl.NumberFormat().format(euros) + " €"
    },

    truncateText(text, maxLength) {
      if (text.length > maxLength) {
        return text.substring(0, maxLength - 3) + '...';
      }
      return text;
    },
  }
}
</script>

<style scoped>
.bilanType-vignette {
  color: var(--main-white);
  text-align: center;
  font: normal normal normal 10px/13px Montserrat-Bold, "Arial", sans-serif;
  letter-spacing: 1px;
  width: 40px;
  height: 20px;
  border-radius: 4px;
  opacity: 1;
  padding: 0.5em;
  margin-left: 1em;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
}


</style>



// WEBPACK FOOTER //
// src/views/contact/ContactShow.vue